/*! Copyright (c) Safe As Milk. All rights reserved. */

class PayIn4 extends HTMLElement {
    #boundOnVariantChange;
    #boundOnClickOutside;
    #boundOnTriggerClick;
    #variantPrices;
    #installments;
    #moneyFormat;
    #tipWrap;
    #trigger;

    constructor() {
        super();
        this.#boundOnVariantChange = this.#onVariantChange.bind(this);
        this.#boundOnClickOutside = this.#onClickOutside.bind(this);
        this.#boundOnTriggerClick = this.#onTriggerClick.bind(this);
    }

    connectedCallback() {
        this.#installments = Math.max(1, Number(this.dataset.installments) || 4);
        this.#moneyFormat = this.dataset.moneyFormat || (window.theme && window.theme.money_format) || "${{amount}}";
        try {
            this.#variantPrices = JSON.parse(this.dataset.variantPrices || "{}");
        } catch (e) {
            this.#variantPrices = {};
        }
        this.amountElement = this.querySelector("[data-pay-in-4-amount]");
        this.#tipWrap = this.querySelector(".pay-in-4__tip-wrap");
        this.#trigger = this.querySelector(".pay-in-4__info-trigger");

        if (this.#trigger) {
            this.#trigger.addEventListener("click", this.#boundOnTriggerClick);
        }
        document.addEventListener("click", this.#boundOnClickOutside);
        document.addEventListener("variant:change", this.#boundOnVariantChange);
    }

    disconnectedCallback() {
        document.removeEventListener("variant:change", this.#boundOnVariantChange);
        document.removeEventListener("click", this.#boundOnClickOutside);
        if (this.#trigger) {
            this.#trigger.removeEventListener("click", this.#boundOnTriggerClick);
        }
    }

    #onTriggerClick(event) {
        event.stopPropagation();
        if (this.#tipWrap) {
            this.#tipWrap.classList.toggle("is-active");
        }
    }

    #onClickOutside(event) {
        if (this.#tipWrap && !this.#tipWrap.contains(event.target)) {
            this.#tipWrap.classList.remove("is-active");
        }
    }

    #onVariantChange(event) {
        const variant = event?.detail?.variant;
        if (!variant || !this.amountElement) return;
        const price = this.#variantPrices[variant.id] ?? variant.price;
        if (typeof price !== "number") return;
        const perInstallment = Math.floor(price / this.#installments);
        this.amountElement.innerHTML = theme.Currency.formatMoney(perInstallment, this.#moneyFormat);
    }
}

if (!customElements.get("pay-in-4")) {
    customElements.define("pay-in-4", PayIn4);
}
